/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Table from '../../../shared/components/MaterialTable';
import { getProductsByRut } from '../../../redux/actions/productsActions';

const headers = [
  { id: 'Id', label: 'ID' },
  { id: 'Marca', label: 'Marca' },
];

class ClientProducts extends Component {
  constructor() {
    super();
    this.state = {
      rut: '',
      page: 1,
      limit: 10,
    };
  }

  componentDidMount = () => {
    const { fetchProducts, id } = this.props;
    this.setState({ rut: id });
    const { page, limit } = this.state;
    fetchProducts({ rut: id, page, limit });
  }

  onChangePage = (page) => {
    const { fetchProducts } = this.props;
    const { rut, limit } = this.state;
    this.setState({ page });
    fetchProducts({ rut, page: page + 1, limit });
  }

  onChangeLimit = (limit) => {
    const { fetchProducts } = this.props;
    const { rut, page } = this.state;
    this.setState({ limit });
    fetchProducts({ rut, page, limit });
  }

  render() {
    const { list, loading, count } = this.props;
    const { page, limit } = this.state;
    const data = list;
    return (
      <div>
        <Table
          cargando={loading}
          data={data}
          headers={headers}
          page={page}
          rowsPerPage={limit}
          selected={[]}
          total={count}
          onChangePage={this.onChangePage}
          onChangeRowsPerPage={this.onChangeLimit}
        />
      </div>
    );
  }
}

ClientProducts.propTypes = {
  fetchProducts: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  count: PropTypes.number.isRequired,
};

const mapState = ({ products }) => ({
  list: products.collection,
  loading: products.loading,
  count: products.count,
});

const mapDispatch = {
  fetchProducts: getProductsByRut,
};

export default connect(mapState, mapDispatch)(ClientProducts);
